import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import logo from "../../assets/WHL-LOGO.png";
import { useCombinedContext } from "../../context/CombinedContext";

const LoanReport = ({ loan, formatPrice, onClose }) => {
  const printRef = useRef(null);
  const handlePrint = useReactToPrint({ content: () => printRef.current });
  const handleOutsideClick = (e) => {
    if (e.target.classList.contains("modal")) onClose();
  };

  const { selectedCompany } = useCombinedContext();
  const company = selectedCompany;
  const employee = loan.employee;

  return (
    <div
      className="modal show d-block"
      tabIndex={-1}
      onClick={handleOutsideClick}
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Loan Report</h5>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>

          {/* PRINTABLE SECTION */}
          <div ref={printRef} className="modal-body modalWhite">
            {/* Header */}
            <div className="d-flex mb-4">
              <img
                src={logo}
                alt="logo"
                style={{ width: 125, marginRight: 20 }}
              />
              <div>
                <h4 className="mb-1">{company.company_name}</h4>
                <p style={{ fontSize: 12 }}>
                  Co Reg No: {company.co_regno} | GST No: {company.gst_no}
                  <br />
                  {company.address}
                  <br />
                  Tel: {company.telephone} | Fax: {company.fax}
                  <br />
                  {company.email}
                </p>
              </div>
            </div>

            <hr />

            {/* Employee Info */}
            <p>
              <strong>Employee Name:</strong> {employee?.name}
            </p>
            <p>
              <strong>Employee No:</strong> {employee?.employeeNo}
            </p>

            <h6 className="mt-4">Loan Details:</h6>
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Application No</th>
                  <th>Loan Type</th>
                  <th>Loan Date</th>
                  <th>Loan Amount</th>
                  <th>Total Repaid</th>
                  <th>Balance</th>
                </tr>
              </thead>
              <tbody>
                {loan.loans?.map((loanItem, idx) => {
                  const totalRepaid =
                    loanItem.repayments?.reduce(
                      (sum, rep) => sum + rep.amount,
                      0,
                    ) || 0;
                  const balance = loanItem.loanAmount - totalRepaid;
                  return (
                    <tr key={idx}>
                      <td>{loanItem.applicationNo}</td>
                      <td>{loanItem.loanType}</td>
                      <td>
                        {new Date(loanItem.loanDate).toLocaleDateString()}
                      </td>
                      <td>{formatPrice(loanItem.loanAmount)}</td>
                      <td>{formatPrice(totalRepaid)}</td>
                      <td>{formatPrice(balance)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            <h6 className="mt-4">Repayment Details:</h6>
            {loan.loans?.map((loanItem, idx) => (
              <div key={idx} className="mb-4">
                <p>
                  <strong>Application No:</strong> {loanItem.applicationNo}
                </p>
                <table className="table table-sm table-bordered">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Date</th>
                      <th>Amount</th>
                      <th>Balance After Payment</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      let runningBalance = loanItem.loanAmount;
                      return loanItem.repayments?.map((rep, repIdx) => {
                        runningBalance -= rep.amount;
                        return (
                          <tr key={rep._id}>
                            <td>{repIdx + 1}</td>
                            <td>{new Date(rep.date).toLocaleDateString()}</td>
                            <td>{formatPrice(rep.amount)}</td>
                            <td>{formatPrice(runningBalance)}</td>
                          </tr>
                        );
                      });
                    })()}
                  </tbody>
                </table>
              </div>
            ))}

            <div className="mt-4">
              <p>
                <strong>Total Loan Amount:</strong>{" "}
                {formatPrice(loan.totalLoanAmount)}
              </p>
              <p>
                <strong>Total Repayment:</strong>{" "}
                {formatPrice(loan.totalRepaymentAmount)}
              </p>
              <p>
                <strong>Balance Amount:</strong>{" "}
                {formatPrice(loan.balanceAmount)}
              </p>
            </div>
          </div>

          <div className="modal-footer">
            <button className="button-2" onClick={onClose}>
              Close
            </button>
            <button className="button-3" onClick={handlePrint}>
              Print
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoanReport;
